import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "aggregation_max",
  "use": "aggregation_max-usage",
  "viewBox": "0 0 15 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 16\" id=\"aggregation_max\"><path d=\"M10.03.97a.754.754 0 0 0-1.06 0c-.29.29-.29.77 0 1.06L10.94 4H4.71C2.11 4 0 6.11 0 8.71V16h1.5V8.71c0-1.77 1.44-3.21 3.21-3.21h6.73L8.97 7.97c-.29.29-.29.77 0 1.06.15.15.34.22.53.22s.38-.07.53-.22L14.06 5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol